import React from 'react'

import ModalWrapper from 'components/Modal/Wrapper'
import useI18n from 'hooks/useI18n'
import { toDateLabel } from './date'
import {
  EmptyState,
  HistoryItem,
  HistoryList,
  HistoryMeta,
  HistoryName,
  ModalBody,
} from './styled'

export default function InviteHistoryModal({ invite, rows, loading, onClose }) {
  const { t } = useI18n()

  return (
    <ModalWrapper
      title={t('staff_essentials_invites_history_modal')}
      text={invite.title || invite.invite_code}
      modalWidth="820px"
      onClose={onClose}
    >
      <ModalBody>
        {loading ? (
          <EmptyState compact>{t('staff_essentials_invites_loading_history')}</EmptyState>
        ) : rows.length ? (
          <HistoryList>
            {rows.map(row => (
              <HistoryItem key={row.documentId || row.id}>
                <HistoryName>{row.full_name || row.email}</HistoryName>
                <HistoryMeta>{row.email}</HistoryMeta>
                {row.access_expires_at ? <HistoryMeta>{t('staff_essentials_invites_column_expires')}: {toDateLabel(row.access_expires_at)}</HistoryMeta> : null}
                <HistoryMeta>{row.institution || t('staff_essentials_invites_no_institution')} · {toDateLabel(row.createdAt)}</HistoryMeta>
                {row.access_expires_at ? <HistoryMeta>{t('staff_essentials_invites_column_expires')}: {toDateLabel(row.access_expires_at)}</HistoryMeta> : null}
              </HistoryItem>
            ))}
          </HistoryList>
        ) : (
          <EmptyState compact>{t('staff_essentials_invites_no_registrations')}</EmptyState>
        )}
      </ModalBody>
    </ModalWrapper>
  )
}
